import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-brand-color-renderer',
  imports: [CommonModule],
  templateUrl: './brand-color-renderer.component.html',
  styleUrl: './brand-color-renderer.component.scss'
})
export class BrandColorRendererComponent implements ICellRendererAngularComp {
  public color?: string;
  public brand?: string;

  agInit(params: ICellRendererParams): void {
    this.load(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.load(params);
    return true;
  }

  private load(params: ICellRendererParams): void {
    const colors = params.colDef?.cellRendererParams?.colors;
    const rowIndex = params.node.rowIndex;
    this.color = (colors && typeof rowIndex === 'number') ? colors[rowIndex] : undefined;
    this.brand = params.value;
  }

}
